import c from '../../utils/c';

/**
 * To use any of these: put a "ribbon" class on the element the ribbon is supposed to "stick to".
 */

export function RibbonTriangle({ className, text }) {
  return (
    <span className={c('ribbonTriangle', className)}>
      <span>{text}</span>
    </span>
  );
}

export function RibbonArrow({ className, text }) {
  return <span className={c('ribbonArrow', className)}>{text}</span>;
}
